"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { useEffect, useRef } from "react";
export default function GetStartedHero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: subheadlineRef,
    isVisible: subheadlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        const rate = scrolled * 0.3;
        parallaxRef.current.style.transform = `translateY(${rate}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="get-started-hero" className="dark bg-background text-foreground relative min-h-screen w-full overflow-hidden flex items-center justify-center">
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541656/img/get_started_hero_background.png)] will-change-transform" style={{
      backgroundAttachment: "scroll"
    }} />

      <div className="absolute inset-0 bg-gradient-to-b from-dark-background/70 via-dark-background/50 to-dark-background/80 backdrop-blur-[2px]" />

      <div className="relative z-10 mx-auto max-w-4xl px-6 py-20 text-center">
        <h1 ref={headlineRef} className={`font-display text-5xl font-bold tracking-tight text-foreground-dark sm:text-6xl md:text-7xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Get Started with AJ Dynasty
        </h1>

        <p ref={subheadlineRef} className={`mt-6 text-lg sm:text-xl md:text-2xl text-foreground-dark/90 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${subheadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Let us handle your administrative needs so you can focus on delivering
          quality care to your clients
        </p>

        <div ref={ctaRef} className={`mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Link to="#contact-form" className="inline-flex items-center justify-center gap-2 rounded-[var(--radius-md)] bg-primary text-foreground-primary px-8 py-4 font-semibold text-lg transition-all duration-[var(--duration-fast)] ease-out hover:brightness-95 hover:-translate-y-0.5 hover:shadow-[var(--shadow-medium)] active:translate-y-0 active:brightness-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
            Request Consultation
            <ArrowRight className="h-5 w-5" />
          </Link>

          <Link to="/ServicesPage" className="inline-flex items-center justify-center gap-2 rounded-[var(--radius-md)] bg-white/10 text-foreground-dark backdrop-blur-sm border-2 border-white/20 px-8 py-4 font-semibold text-lg transition-all duration-[var(--duration-fast)] ease-out hover:bg-white/20 hover:-translate-y-0.5 hover:shadow-[var(--shadow-medium)] active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
            View Our Services
          </Link>
        </div>
      </div>
    </section>;
}